export const PRIME = {
  "199": {
    M1: "PRIME199M1",
    S1: "PRIME199S1",
  },
  "259": {
    S1: "PRIME259S1",
    S2: "PRIME259S2",
    S2MUST: "PRIME259S2MUST",
    S2DC05: "PRIME259S2DC05",
    S2DC10: "PRIME259S2DC10",
    Y2: "PRIME259Y2",
    M1: "PRIME259M1",
    M2: "PRIME259M2",
    M3: "PRIME259M3",
    M4: "PRIME259M4",
    M990: "PRIME259M990",
    M4DC05: "PRIME259M4DC05",
    M4DC10: "PRIME259M4DC10",
    M4DC30: "PRIME259M4DC30",
    MS49: "PRIME259MS49",
    MS99: "PRIME259MS99",
    MS149: "PRIME259MS149",
    MS199: "PRIME259MS199",
    MS300: "PRIME259MS300",
  },
  "279": {
    M1: "PRIME279M1",
    S1: "PRIME279S1",
    M1DC05: "PRIME279M1DC05",
    M1DC10: "PRIME279M1DC10",
    S1DC05: "PRIME279S1DC05",
    S1DC10: "PRIME279S1DC10",
    M990: "PRIME279M990",
    MS99: "PRIME279MS99",
    MS99DC06: "PRIME279MS99DC06",
    MS99DC10: "PRIME279MS99DC10",
    MS99DC14: "PRIME279MS99DC14",
    MS99DC17: "PRIME279MS99DC17",
    MS99DC20: "PRIME279MS99DC20",
    MS279: "PRIME279MS279",
    MS279DC20: "PRIME279MS279DC20",
    MS558: "PRIME279MS558",
    MS558DC25: "PRIME279MS558DC25",
    M1DC14: "PRIME279M1DC14",
    S1DC14: "PRIME279S1DC14",
    M1DC15: "PRIME279M1DC15",
    S1DC15: "PRIME279S1DC15",
    MS99DC15: "PRIME279MS99DC15",
    M1AF2: "PRIME279M1AF2",
    M99AF2: "PRIME279M99AF2",
    S1AF2: "PRIME279S1AF2",
    MUST2509M1: "PRIME279MUST2509M1",
    MUST2509S1: "PRIME279MUST2509S1",
    MUST2510M1: "PRIME279MUST2510M1",
    MUST2510S1: "PRIME279MUST2510S1",
    M1HSV1: "PRIME279M1HSV1",
    M1HSV2: "PRIME279M1HSV2",
    S1HSV1: "PRIME279S1HSV1",
    S1HSV2: "PRIME279S1HSV2",
    MUST2511S1GDV: "PRIME279MUST2511S1GDV",
    MUST2511M1GDV: "PRIME279MUST2511M1GDV",
    M1PBK03: "PRIME279M1PBK03",
    S1PBK03: "PRIME279S1PBK03",
    M1PBK02: "PRIME279M1PBK02",
    S1PBK02: "PRIME279S1PBK02",
  },
  "299": "PRIME299",
};

export const PRODUCT_GROUP = {
  basicliv: "basicliv",
  wellcare: "wellcare",
  "990": "990",
  "100": "100",
  event_25c: "event_25c",
  hsp: "hsp",
  event_25e: "event_25e",
  event_25f: "event_25f",
  event_25g: "event_25g",
};

export const LIVE_PRIME_PAY = {
  monthly: PRIME["279"].M1,
  single: PRIME["279"].S1,
  saving: PRIME["279"].MS99,
};
